export function uniqueBy<T>(items: T[], getId: (item: T) => string): T[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    const id = getId(item);
    if (!id || seen.has(id)) {
      return false;
    }
    seen.add(id);
    return true;
  });
}
